/**
 * Follow-Up Settings API
 *
 * API client functions for follow-up configuration, testing, and activity.
 */

import { api } from './client';
import type { FollowUpConfig, FollowUpSent } from '../types';

/**
 * Get current follow-up config (or defaults if none saved)
 */
export async function getFollowUpConfig(): Promise<FollowUpConfig> {
  return api.get<FollowUpConfig>('/follow-ups/config');
}

/**
 * Save follow-up config (partial merge)
 */
export async function saveFollowUpConfig(
  config: Partial<FollowUpConfig>
): Promise<FollowUpConfig> {
  return api.put<FollowUpConfig>('/follow-ups/config', config);
}

/**
 * Send a test follow-up for a specific rule + order
 */
export async function testFollowUp(
  ruleId: string,
  orderId: string
): Promise<{ success: boolean; message?: string; error?: string }> {
  return api.post('/follow-ups/test', { ruleId, orderId });
}

/**
 * List recent follow-up activity (paginated)
 */
export async function getFollowUpActivity(
  page = 1,
  limit = 20
): Promise<{
  activity: FollowUpSent[];
  page: number;
  limit: number;
  hasMore: boolean;
}> {
  return api.get('/follow-ups/activity', { page, limit });
}
